import axios from './HTTP'

export default {
  update (idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/clock_entries/${ idAndFields.id }.json`, idAndFields)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  destroy (entryId, callback, errorCallback) {
    axios
      .delete(`/api/clock_entries/${ entryId }.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  managerCreate (shiftId, callback, errorCallback) {
    axios
      .post(`/api/clock_entries/manager_create.json`, {
        shift_id: shiftId
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  clockIn (params, callback, errorCallback) {
    axios
      .post(`/api/clock_entries.json`, {
        user_id: params.userId,
        shift_id: params.shiftId,
        start: true,
        punch_time: params.punchTime,
        endcap: params.endcap,
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  clockInOverride (params, callback, errorCallback) {
    axios
      .post(`/api/clock_entries.json`, {
        override: true,
        override_username: params.overrideUsername,
        override_password: params.overridePassword,
        user_id: params.userId,
        shift_id: params.shiftId,
        start: true,
        punch_time: params.punchTime,
        endcap: params.endcap,
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  clockOut (params, callback, errorCallback) {
    axios
      .post(`/api/clock_entries.json`, {
        user_id: params.userId,
        shift_id: params.shiftId,
        start: false,
        punch_time: params.punchTime,
        endcap: params.endcap,
        needs_override: params.needsOverride
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  clockOutOverride (params, callback, errorCallback) {
    axios
      .post(`/api/clock_entries.json`, {
        override: true,
        override_username: params.overrideUsername,
        override_password: params.overridePassword,
        user_id: params.userId,
        shift_id: params.shiftId,
        start: false,
        punch_time: params.punchTime,
        endcap: params.endcap,
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  getPunches (params, callback, errorCallback) {
    axios
      .get(`/api/clock_entries.json`, {
        params: {
          shift_id: params.shiftId
        }
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  getCurrentUserLastPunches (callback, errorCallback) {
    axios
      .get(`/api/clock_entries/current_user_last_shift.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  }
}
